import http from  './axios'
export const accountList = param =>{return http.post("clinic-manager/settlement/getHisCaseList",param).then(res=>res.data.data)};
//已结算列表
export const noAccountList = param =>{return http.post("clinic-manager/settlement/getNoSettlementList",param).then(res=>res.data.data)};
//未结算列表
export const settleAccount = param =>{return http.post("clinic-manager/settlement/settlement",param).then(res=>res.data.data)};
//结算
export const getSettleById = param =>{return http.post("clinic-manager/settlement/getNoSettlementById",param).then(res=>res.data.data)};
//未结算根据id

export const batchSettle = param =>{return http.post("clinic-manager/settlement/settlements",param).then(res=>res.data.data)};
//批量结算
export const noSamping = param =>{return http.post("clinic-manager/settlement/getSpecimenSamplingList",param).then(res=>res.data.data)};
//未采集列表
export const specimenBarCode = param =>{return http.post("clinic-manager/settlement/specimenBarCode",param).then(res=>res.data.data)};
//绑定条码
export const weChatPay = param =>{return http.post("clinic-manager/settlement/initWeChatPayment",param).then(res=>res.data.data)};
//未支付微信扫码支付
export const inWeChatPay = param =>{return http.post("clinic-manager/settlement/initWeChatPayIn",param).then(res=>res.data.data)};
//支付中微信扫码支付
export const isPaySuccess = param =>{return http.post("clinic-manager/settlement/getPayStateById",param).then(res=>res.data.data)};
//根据支付id查询是否支付成功
export const inPayList = param =>{return http.post("clinic-manager/settlement/getHisPaymentInList",param).then(res=>res.data.data)};
//支付中列表
export const delPayIn = param =>{return http.post("clinic-manager/settlement/delPayById",param).then(res=>res.data.data)};
//支付中取消支付
export const orderByPayId = param =>{return http.post("clinic-doctor/order/getOrderByOrderPayId",param).then(res=>res.data.data)};
//根据支付id查询订单

export const  orderDetail = param  =>{return http.post('partner-sale/order/getOrderDetailsById',param).then(res=>res.data.data)};
//根据订单id查询详情
export const  getPDF = param  =>{return http.post('/partner-sale/order/getOrderReportByOrderId',param).then(res=>res.data.data)};
//根据订单id查询PDF报告




// WEBPACK FOOTER //
// ./src/api/outside.js